import React, { useState, useEffect } from 'react';
import styles from '../../pages/Landing/LandingPage.module.css';
import { FaBullhorn } from 'react-icons/fa';
import api from '../../api/api.js'; // Import your configured axios instance

// ... (your formatActivity helper function remains the same)
const formatActivity = (activity) => {
    switch (activity.activityType) {
        case 'USER_SEARCH':
            return {
                text: `Someone in postcode ${activity.activityDetail1} is searching for a`,
                emphasis: activity.activityDetail2
            };
        case 'PROFILE_VIEW_BUSINESS':
            return {
                text: 'A user just viewed the profile of',
                emphasis: activity.activityDetail1
            };
        case 'QUOTE_SENT':
             return {
                text: `${activity.activityDetail1} just sent a quote to a homeowner.`,
                emphasis: ''
            };
        case 'FAVORITE_ADDED':
            return {
                text: `A user just favorited`,
                emphasis: activity.activityDetail3
            };
        case 'REVIEW_LEFT':
            return {
                text: `A new review was left for`,
                emphasis: activity.activityDetail1
            };
        default:
            return null;
    }
};


const SocialProofEngine = () => {
    // ... (your state and timing constants remain the same)
    const [activities, setActivities] = useState([]);
    const [currentActivityIndex, setCurrentActivityIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    const VISIBLE_DURATION_MS = 7000; 
    const DELAY_BETWEEN_MS = 15000;
    const POLLING_INTERVAL_MS = 5 * 60 * 1000;

    useEffect(() => {
        const fetchAndSetActivities = async () => {
            try {
                // Use the axios instance. The base URL is already configured.
                // The correct endpoint path is '/api/activity/latest'
                const response = await api.get('/api/activity/getlatest');

                // With axios, the data is directly available in `response.data`
                const data = response.data;
                console.log("Data from Axios:", data);

                const formattedActivities = data.map(formatActivity).filter(Boolean);
                setActivities(formattedActivities);
            } catch (error) {
                // Axios throws an error for non-2xx responses, which will be caught here.
                console.error("Failed to fetch activities:", error);
            }
        };

        fetchAndSetActivities();
        const intervalId = setInterval(fetchAndSetActivities, POLLING_INTERVAL_MS);
        return () => clearInterval(intervalId);
    }, []);

    // ... (the rest of your component logic remains the same)
    useEffect(() => {
        if (activities.length === 0) return;

        const showNextActivity = () => {
            setIsVisible(true);

            const hideTimer = setTimeout(() => {
                setIsVisible(false);
            }, VISIBLE_DURATION_MS);

            const nextTimer = setTimeout(() => {
                setCurrentActivityIndex((prevIndex) => (prevIndex + 1) % activities.length);
            }, VISIBLE_DURATION_MS + 500);

            return () => {
                clearTimeout(hideTimer);
                clearTimeout(nextTimer);
            };
        };

        const displayInterval = setInterval(showNextActivity, DELAY_BETWEEN_MS);
        const initialTimeout = setTimeout(showNextActivity, 2000);

        return () => {
            clearInterval(displayInterval);
            clearTimeout(initialTimeout);
        };
    }, [activities, currentActivityIndex]);

    if (activities.length === 0) return null;

    const notification = activities[currentActivityIndex];

    return (
        <div className={`${styles.activityToast} ${isVisible ? styles.toastVisible : ''}`}>
            <FaBullhorn className={styles.toastIcon} />
            <div>
                {notification.text} <strong>{notification.emphasis}</strong>
            </div>
        </div>
    );
};

export default SocialProofEngine;